import { useCallback } from "react";
import { useAuthContext } from "./AuthContext";
import { tokenStorage } from "./storage";
import type { MeResponse } from "../Components/interface";

const API_BASE = process.env.REACT_APP_AUTH_API_URL;

async function verifyToken(token: string): Promise<boolean> {
  try {
    console.log("Verifying token:", token);
    const res = await fetch(`${API_BASE}/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return false;
    const data: MeResponse = await res.json();
    return Boolean(data?.username && data?.credit && data.credit > 0); // 按你的接口字段调整
  } catch {
    return false;
  }
}

interface UseAuthReturn {
  /**
   * 包装任意回调函数，调用前自动验证登录状态。
   * 用法：<button onClick={withAuth(handleDelete)}>删除</button>
   */
  withAuth: <T extends unknown[]>(
    action: (...args: T) => unknown,
  ) => (...args: T) => Promise<void>;
}

export function useAuth(): UseAuthReturn {
  const { openLoginModal } = useAuthContext();

  const withAuth = useCallback(
    <T extends unknown[]>(action: (...args: T) => unknown) =>
      async (...args: T): Promise<void> => {
        const token = tokenStorage.get();
        if (token) {
          const valid = await verifyToken(token);
          if (valid) {
            action(...args);
            return;
          }
          tokenStorage.remove();
        }

        openLoginModal(() => action(...args));
      },
    [openLoginModal],
  );

  return { withAuth };
}
